import PropTypes from "prop-types";
import React, { FC, ReactNode } from "react";

import styles from "./Card.module.scss";

type CardProps = {
  children: ReactNode;
};

export const Card: FC<CardProps> = ({ children }) => <div className={`card ${styles.card}`}>{children}</div>;

Card.propTypes = {
  children: PropTypes.node.isRequired,
};
